import React, { Component } from 'react'
import { Header, Menu, Footer } from '../../'
import { Card, CardTitle, CardImg, CardText, CardBody } from 'reactstrap'
import './index.scss'

import promotionOne from '../../../assets/images/promotion/promotion_01.jpg'
import promotionTwo from '../../../assets/images/promotion/promotion_02.jpg'
import promotionThree from '../../../assets/images/promotion/promotion_03.jpg'

class PromotionDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: [
        {
          title: 'เคาน์เตอร์ถอดประกอบ',
          text: 'เหมาะสำหรับขายหน้าร้านหรือออกงานนอกสถานที่ พับเก็บง่าย',
          src: promotionOne
        },
        {
          title: 'เคาเตอร์',
          text: 'เหมาะสำหรับตั้งขายหน้าร้าน มีตู้เก็บของด้านหลังและมีลิ้นชักล๊อคเก็บได้',
          src: promotionTwo
        },
        {
          title: 'รถเข็น',
          text: 'เหมาะสำหรับขายตามจุดต่างๆ เคลื่อนย้ายสะดวก วัสดุแข็งแรงทนทานทุกสถานที่',
          src: promotionThree
        }
      ]
    }
  }
  render() {
    return (
      <>
        <Header />
        <div className="container-lg p-0">
          <Menu />
        </div>
        <div className="ch-promotion-detail">
          <div className="container-fluid">
            <h1 className="display-4 text-center font-weight-bold mt-5 mb-3">
              แฟรนไชส์ เราไม่ขาย เราแจก{' '}
              <span className="m-0" style={{ color: '#ff7550' }}>
                ฟรี!!
              </span>
            </h1>
            <div className="row mb-5">
              <div className="col-12 col-md-8 offset-md-2">
                <div className="row">
                  <div className="col-12 mt-4">
                    <Card body>
                      <CardText>
                        ตลอดระยะเวลากว่า 20 ปีที่ Brand "Chef Hung"
                        ได้รับการยอมรับจากลูกค้ามาโดยตลอดจนถึงปัจจุบัน นโยบายบริษัทที่ "Chef Hung"
                        ยึดถือไว้คือ "จงซื่อสัตย์กับลูกค้า" และจากสิ่งนี้เองทำให้ Brand "Chef Hung"
                        ได้ถูกส่งต่อสู่รุ่นปัจจุบัน โดยยึดมั่นสิ่งนี้เป็นสำคัญมาโดยตลอดเช่นเดียวกัน
                      </CardText>
                      <CardText>
                        Chef Hung ได้มีการผลิตทั้งลูกชิ้นหมู
                        ลูกชิ้นเนื้อและยังได้เพิ่มการผลิตสินค้าจำพวกของปิ้ง ของทอดต่างๆ เช่น
                        ลูกชิ้นปิ้ง ไส้อั่ว ไส้กรอกอีสาน ไส้กรอกวุ้นเส้น ไส้กรอกหมูกระเทียมพริกไทย
                        ไส้กรอกหมูกระเพรา ไส้กรอกรมควัน
                        เพื่อตอบสนองความต้องการของลูกค้าให้ได้ครบทุกส่วน
                      </CardText>
                      <CardText>
                        ถ้าหากคุณกำลังมองหาอาชีพเสริมหรืออาชีพหลักแฟรนไชส์ลูกชิ้น-ไส้กรอก“นายฮั่ง”
                        เป็นอีกหนึ่งทางเลือกที่จะสามารถสร้างกำไรให้กับคุณจากหลักพันไปจนถึงหลักหมื่นได้ง่ายๆ
                        โดยที่ไม่ต้องลงทุนใดๆ
                      </CardText>
                      <CardText>
                        <strong>คุณสมบัติผู้ซื้อแฟรนไชส์:</strong> สำหรับผู้มีใจรักในการขาย
                        ไม่เสียค่าแฟรนไชส์ใดๆ เพียงมัดจำ (2,500 บาท)
                      </CardText>
                      <CardText>
                        <strong>สิ่งที่แฟรนไชส์จะได้รับ:</strong>
                      </CardText>
                      <ol>
                        <li>รถเข็น หรือ เคาน์เตอร์พร้อมสติกเกอร์ตกแต่งนายฮั่ง</li>
                        <li>ผ้ากันเปื้อนเชฟฮั้ง</li>
                        <li>หมวกตะข่ายคลุมผม</li>
                        <li>คำแนะนำในการขายจากผู้เชี่ยวชาญ</li>
                      </ol>
                      <CardText>
                        <strong>
                          **พิเศษเพียงจ่ายเพิ่ม 1,000 บาท ท่านจะได้รับชุดอุปกรณ์พร้อมขายดังนี้
                        </strong>
                      </CardText>
                      <ol>
                        <li>เตาย่างแบบใช้ถ่าน (เบอร์ 16)</li>
                        <li>หม้อใส่น้ำจิ้มพร้อมที่ตัก 1 ชุด</li>
                        <li>มีด เขียง ทีคีบ</li>
                        <li>ถาดพร้อมที่วางจำนวน 2 ชุด</li>
                      </ol>
                      <CardText className="m-0">สนใจติดต่อสอบได้ที่เบอร์</CardText>
                      <CardText>081-806-2929</CardText>
                    </Card>
                  </div>
                </div>
                <div className="row">
                  {this.state.items.map((item, i) => {
                    return (
                      <div className="col-12 col-xl-4 offset-xl-0 mt-4" key={i}>
                        <Card className="ch-promotion-detail-item">
                          <CardImg top width="100%" src={item.src} alt="chefhung-franchising" />
                          <CardBody className="fix-height-220">
                            <CardTitle className="text-primary font-weight-bold">
                              <h2 className="m-0">{item.title}</h2>
                            </CardTitle>
                            <h5 className="mt-3 mb-0">{item.text}</h5>
                          </CardBody>
                        </Card>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

export default PromotionDetail
